// utils
import axios from '../../utils/axios';

const addUserToPartner = async (data, partnerId) => {
  try {
    const response = await axios({
      method: 'put',
      url: `/partners/${partnerId}/user`,
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { addUserToPartner };
